/**
 * 部分由 Vidu 生成的视频，在读取元数据时会比配置时长略长。
 * 例如配置为 5s 的视频，实际读取结果可能是 5.4s。
 * 这里保留真实业务上限，额外的 0.4s 只用于时长校验兼容。
 */
export const VIDEO_DURATION_COMPATIBILITY_BUFFER_IN_SECONDS = 0.4;

interface VideoDurationRangeOptions {
  duration?: number | null;
  minDuration?: number;
  maxDuration?: number;
}

export function getMaxVideoDurationWithTolerance(maxDuration?: number): number | undefined {
  if (typeof maxDuration !== 'number') {
    return undefined;
  }

  return maxDuration + VIDEO_DURATION_COMPATIBILITY_BUFFER_IN_SECONDS;
}

export function isVideoDurationWithinRange({ duration, minDuration, maxDuration }: VideoDurationRangeOptions): boolean {
  if (typeof duration !== 'number' || !Number.isFinite(duration)) {
    return false;
  }

  if (minDuration !== undefined && duration < minDuration) {
    return false;
  }

  const maxDurationWithTolerance = getMaxVideoDurationWithTolerance(maxDuration);
  if (maxDurationWithTolerance !== undefined && duration > maxDurationWithTolerance) {
    return false;
  }

  return true;
}

/**
 * 用于 5s、8s 这类离散业务时长配置。
 */
export function normalizeDiscreteVideoDurationToSeconds(duration?: number | null): number {
  return Math.round(duration || 0);
}

/**
 * 用于视频时间轴、可裁剪范围等连续时长场景，避免 5.4s 被截成 5s。
 */
export function ceilVideoDurationToSeconds(duration?: number | null): number {
  return Math.ceil(duration || 0);
}
